const GET_SERVICE_INFORMATION = "/webservice/contractor/get-service-details";
const GET_SERVICE_DETAILS_BY_INQUIRY_ID = "/webservice/get-inquiry-details-by-id";
const GET_BOOKING_SERVICES_DETAILS_BY_BOOKING_ID = "/webservice/get-booking-services-details-by-id";

module.exports = {
    getServiceDetails: function (services, companyId, categoryId,isCustom,withCategoryName,locationData) {
        return window.axios.get(GET_SERVICE_INFORMATION, {
            params: {
                company_id: companyId,
                service_id: services,
                category_id: categoryId,
                is_custom: isCustom,
                location_data: JSON.stringify(locationData),
                with_category_name: withCategoryName,
                os: 'web'
            }
        });
    },
    getServiceDetailsByInquiryId: function (inquiryId,companyId,withCategoryName) {
        return window.axios.get(GET_SERVICE_DETAILS_BY_INQUIRY_ID, {
            params: {
                inquiry_id: inquiryId,
                with_category_name: withCategoryName,
                company_id: companyId,
            }
        });
    },
    getBookingServicesDetailsByBookingId: function (bookingId,companyId,withCategoryName) {
        return window.axios.get(GET_BOOKING_SERVICES_DETAILS_BY_BOOKING_ID, {
            params: {
                booking_id: bookingId,
                with_category_name: withCategoryName,
                company_id: companyId,

            }
        });
    }

};  
